import { render, staticRenderFns } from "./OrderInfoAll.vue?vue&type=template&id=4422887e&"
import script from "./OrderInfoAll.vue?vue&type=script&lang=js&"
export * from "./OrderInfoAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports